import TextInterDEPRECATED from '@lyra/core/components/TextInterDEPRECATED'
import Tooltip from '@lyra/core/components/Tooltip'
import formatDateTime from '@lyra/core/utils/formatDateTime'
import formatRelativeDateTime from '@lyra/core/utils/formatRelativeDateTime'

type Props = {
  // Timestamp in seconds
  timestamp: number
}

export default function TimeCell({ timestamp }: Props) {
  return (
    <Tooltip
      content={formatDateTime(timestamp, {
        hideMins: false,
        hideYear: false,
      })}
      trigger={
        <TextInterDEPRECATED color="secondary">
          {formatRelativeDateTime(new Date(timestamp), { truncate: true })}
        </TextInterDEPRECATED>
      }
    />
  )
}
